export const ROLE_PRODUCT_TEAM_DASHBOARD = "APL213643-MyHelp-ProductTeam-Dashboard";
export const ROLE_PRODUCT_TEAM_DASHBOARD_PO_ACTIONS_FOR_YOU = "APL213643-MYHELP-PO-DASHBOARD-Action-for-you";